import { ReactNode } from 'react';

export interface IAnimatedCollapseProps {
    collapsed: boolean;
    durationMs?: number;
    children: ReactNode;
}

export const AnimatedCollapse: React.FC<IAnimatedCollapseProps> = ({ collapsed, durationMs = 500, children }) => {

    const style = {
        height: collapsed ? 0 : 'auto',
        overflow: 'hidden',
        transition: `height ${durationMs}ms`,
        interpolateSize: 'allow-keywords'
    } as React.CSSProperties & {interpolateSize: 'allow-keywords'};

    return (
        <div style={style}>
            {children}
        </div>

    );
};
